var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-answer"},_vm._l((_vm.tokens),function(token,i){return _c('AskMarkdownTokenRenderer',{key:`${_vm.id}:${i}`,attrs:{"token":token,"hovered":_vm.hovered,"contexts":_vm.contexts,"links":_vm.links},on:{"md-event":function($event){return _vm.$emit('md-event', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }